<template>
    <div id="page">
        <div class="page-content">
            <div class="fixed-top-box">
                <div class="page-title page-title-small">
                    <h2>
                        <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                        حضور و غیاب
                        <!--<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>-->
                    </h2>
                    <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                    <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
                </div>
                <div class="card header-card shape-rounded" data-card-height="100">
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>
                </div>
                <div class="card card-style mb-2">
                    <div class="p-3 d-flex">
                        <button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
                            <i class="fa fa-filter text-white"></i>
                        </button>
                        <div class="w-100">
                            <div v-if="btnAutomaticLoc">
                                <button type="button" v-if="isAutomaticStart==false" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="StartAutomatic" style="max-height:31px">
                                    <i class="fa fa-check font-10 ml-2"></i>
                                    شروع ثبت موقعیت اتوماتیک
                                </button>
                                <button type="button" v-if="isAutomaticStart==true" class="btn btn-xxs btn-full bg-red1-light rounded-sm font-900 w-100" @click.prevent="StopAutomatic" style="max-height:31px">
                                    <i class="fa fa-times font-10 ml-2"></i>
                                    توقف ثبت موقعیت اتوماتیک
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <span data-menu="menu-language" class="optionMenu"></span>


            <div class="main-content-box">
                <div class="card card-style mb-2" @click.prevent="openDetails(task.userPresenceId)" v-for="task in UserPresenceList" :key="task.userPresenceId">
                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div py-2 px-3">
                            <div>
                                <b class="font-13 text-dark">{{task.title}}</b>
                            </div>
                            <div>
                                <span class="text-muted d-inline-block text-left ltr">{{task.createDateTime}}</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="d-inline-flex align-items-center">
                                    <!--اگر کاربر تصویر پروفایل نداشت-->
                                    <!--<i class="fa fa-user-circle color-green2-light ml-2 font-30"></i>-->
                                    <!--تصویر کاربر ثبت کننده-->
                                    <img v-if="task.userImg!=null && task.userImg!=''" :src="task.userImg" alt="userProfileImg" width="30" height="30" class="rounded-circle ml-2 img-object-fit" />
                                    <i v-else class="fa fa-user-circle color-green2-light ml-2 font-30"></i>

                                    <span class="text-muted">{{task.userTitle}}</span>
                                </div>
                                <span @click.stop="showMenu(task.userPresenceId)" width="10%"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-style" v-if="Loading==false && NoMoreData==false && UserPresenceList.length>0 && UserPresenceList.length%10==0">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100">
                            <button class="btn btn-outline-info rounded-m" @click="getNextPageForUserPresenceList">نمایش بیشتر</button>
                        </div>
                    </div>
                </div>
                <!--<div class="card card-style" v-if="Loading">
                    <div class="content">
                        <div class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>-->
                <div class="card card-style" v-if="UserPresenceList.length==0 && Loading==false">
                    <div class="content">
                        <div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
                        <p class="text-center py-3">هیچ موردی یافت نشد.</p>
                    </div>
                </div>
            </div>
        </div>
        <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
            <div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
                <router-link to="/CreateUserPresence">
                    <div class="icon icon-m rounded-m color-white bg-green2-light">
                        <i class="fa fa-plus"></i>
                    </div>
                </router-link>
            </div>
        </transition>

        <div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
            <div class="m-3">
                <div class="list-group list-custom-small">
                    <router-link :to="{ name: 'EditUserPresence', params: { userPresenceId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>

                    <button @click="deleteUserPresence" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

                </div>
                <div class="clear"></div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>



        <div id="searchModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header align-items-center">
                        <h4 class="modal-title mt-0">جستجو</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body m-0">
                        <div class="mb-3">
                            <div class="w-100 search-box rounded-m position-relative">
                                <i class="fa fa-search pr-3"></i>
                                <input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
                            </div>
                        </div>
                        <myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>
                        <button type="button" class="btn btn-xxs btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
                            <i class="fa fa-search ml-2"></i>
                            جستجو
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!--<div id="userPresenceHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserPresence.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-UserPresence.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
    <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
        <div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
            <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
        </div>
    </transition>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    import MyTeamList from '../Components/MyTeamList.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu,
            "myTeamList": MyTeamList,
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedWorkId: 0,
                btnAutomaticLoc: false,
                isAutomaticStart: false,
                pageLoaded: false,
                mapLocationObject: null,
                userId: null,
            };
        },
        computed: {
            UserPresenceList() {
                return this.$store.getters.GetUserPresenceList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            },
            NoMoreData() {
                return this.$store.getters.GetUserPresenceNoMoreData;
            },
            localUserListList() {
                return this.$store.getters.GetLocalUserListList;
            },
             UpdateUserPresenceList() {
                return this.$store.getters.GetUpdateUserPresenceList;
            },
        },

        created() {
            console.log(this.NoMoreData);
            this.GetAutoUserLocationStatus();
            this.$store.dispatch("GetLocalUserListListFromServerForMap", { workGroupId: null });
            this.$store.dispatch("GetUserPresenceListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey,
                userId: this.userId,
                selfUser: true
            });
        },
        methods: {
            selectUser(d) {
                this.userId = d;
            },
            StartAutomatic() {
                try {
                    this.$http
                        .get("UserPresence/AutoUserLocationStart")
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                window.location.reload();
                            }
                        });

                } catch (e) {
                    console.log(e);
                }
            },
            StopAutomatic() {
                try {

                    this.$http
                        .get("UserPresence/AutoUserLocationStop")
                        .then((data) => {
                            var res = data.data;
                            if (res.isSuccess) {
                                window.location.reload();
                            }
                        });
                } catch (e) {
                    console.log(e);
                }

            },
            GetAutoUserLocationStatus() {
                this.$http
                    .get("UserPresence/GetAutoUserLocationStatus")
                    .then((data) => {
                        var res = data.data;
                        if (res.isSuccess) {
                            this.isAutomaticStart = true;
                        } else {
                            this.isAutomaticStart = false;
                        }
                        this.btnAutomaticLoc = true;
                    });
            },
            showAddButton() {
                this.pageLoaded = true;
                var x = screen.height;
                var topForAddButton = x - 220 + 'px';
                this.$refs.addBtn.style.top = topForAddButton;
            },
            showMenu(userPresenceId) {
                this.selectedWorkId = userPresenceId;
                document.getElementsByClassName("optionMenu")[0].click();
            },
            filterList() {
                this.page = 1;
                this.$store.dispatch("GetUserPresenceListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey,
                    userId:this.userId
                });
            },
       
            deleteUserPresence() {
                document.getElementsByClassName('menu-hider')[0].click();
                VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
                    this.$http.get("UserPresence/DeleteUserPresence?id=" + this.selectedWorkId)
                        .then(data => {
                            var res = data.data.toString();
                            if (res==="1") {
                                this.showSuccessMessage("با موفقیت حذف شد.");
                                this.filterList();

                            }
                            else {
                                this.showErrorMessage(res);
                            }


                        });
                });
            },
            openDetails(userPresenceId) {
                this.$router.push({ name: 'EditUserPresence', params: { userPresenceId: userPresenceId } });
                document.getElementsByClassName('menu-hider')[0].click();
            },
            getNextPageForUserPresenceList() {

                this.page++;
                console.log(this.page);
                this.$store.dispatch("GetUserPresenceListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },
            pauseVid(id) {
                console.log(id);
                if (id != null) {
                    console.log("pause");
                    var vid = document.getElementById(id);
                    vid.pause();
                }
            },
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
        },
        activated() {
            console.log("mounted");
            this.showAddButton();
            if (this.UpdateUserPresenceList == true) {
                this.page = 1;
                this.filterList();
            }
            // this.getNextPageForUserPresenceList();
        },
        mounted() {
            this.showAddButton();
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
        }
    };
</script>
